/* eslint-disable no-param-reassign */
export default {
  playPauseSound(state, value) {
    state.soundPlaying = value;
  },
  muteSound(state, value) {
    state.soundMuted = value;
  },
  stopSound(state, value) {
    state.soundStopped = value;
  },
  setSoundVolume(state, value) {
    state.soundVolume = value;
  },
  setShowCaption(state, value) {
    state.showCaption = value;
  },
  setCaptionFontSize(state, value) {
    state.captionSize = value;
  },
  setCaptionFontSizePercentage(state, value) {
    state.captionSizePercentage = value;
  },
  setAnimationsMode(state, value) {
    state.animationsOn = value;
  },
  setOnGoingAnimation(state, tl) {
    state.onGoingAnimation = tl;
  },
  setCurrentTweenData(state, index) {
    state.currentTweenIndex = index;
  },
  setCurrentKeyboardingSegment(state, segment) {
    state.currentKeyboardingSegment = segment;
  },
  setTotalKeyboardingSegment(state, segment) {
    state.totalKeyboardingSegment = segment;
  }
};
